import { teamTypes, TeamFilters } from "redux/Ldb/types/teamTypes";
import { teamService } from "services/Ldb/teamService";
import { Dispatch } from "redux";
import { toast } from "react-hot-toast";
import CustomToast from "components/common/CustomToast";

export const teamActions = {
    fetchTeamMembers,
    fetchTeamMembers2,
    resetFetchTeamMembers,
    resetFetchTeamMembers2,
    request,
    success,
    failure,
};

function fetchTeamMembers(
    teamLimit: number | string,
    search?: string,
    page?: number,
    token?: string
) {
    return (dispatch: Dispatch) => {
        dispatch(request(teamTypes.FETCH_TEAM_MEMBERS_REQUEST));

        teamService.getTeamMembers(teamLimit as string, search as string, page, token).then(
            (res) => {
                dispatch(success(teamTypes.FETCH_TEAM_MEMBERS_SUCCESS, res?.data));
            },
            (error) => {
                if (error.message) {
                    toast.custom((t) => <CustomToast t={t} message={error.message} type="error" />);
                    dispatch(failure(teamTypes.FETCH_TEAM_MEMBERS_FAILURE, error.message));
                }
            }
        );
    };
}

function fetchTeamMembers2(filters?: TeamFilters, token?: string) {
    return async (dispatch: Dispatch) => {
        dispatch(request(teamTypes.FETCH_TEAM_MEMBERS2_REQUEST));
        try {
            const response = await teamService.getTeamMembers2(filters, token);
            dispatch(success(teamTypes.FETCH_TEAM_MEMBERS2_SUCCESS, response));
        } catch (error) {
            dispatch(failure(teamTypes.FETCH_TEAM_MEMBERS2_FAILURE, error));
        }
    };
}

// Reset actions
function resetFetchTeamMembers() {
    return (dispatch: Dispatch) => {
        dispatch({ type: teamTypes.RESET_FETCH_TEAM_MEMBERS });
    };
}

function resetFetchTeamMembers2() {
    return (dispatch: Dispatch) => {
        dispatch({ type: teamTypes.RESET_FETCH_TEAM_MEMBERS2 });
    };
}

function request(type: string) {
    return { type };
}

function success(type: string, data?: any) {
    return { type, payload: data };
}

function failure(type: string, error?: any) {
    return { type, payload: error };
}
